/**
 * Globale Config Datei
 */
export abstract class Config {

    private static readonly ApiEndpoints = {
        development: "https://localhost:7094/api/",
        developmentServer: "https://dev.maxweb.paus.ch:7094/api/",
        production: "https://maxweb.paus.ch:5000/api",
    };

    public static isDevelopment(): boolean {
        return this.isLocalDevelopment() || this.isServerDevelopment();
    }

    public static isProduction(): boolean {
        return import.meta.env.VITE_APP_ENDPOINT_URL === "production";
    }

    public static isStaging(): boolean {
        return import.meta.env.VITE_APP_ENDPOINT_URL === "staging";
    }

    public static isLocalDevelopment(): boolean {
        return import.meta.env.VITE_APP_ENDPOINT_URL === "development";
    }

    public static isLocalDevelopmentApi(): boolean {
        return import.meta.env.VITE_APP_ENV === "developmentApi";
    }

    public static isServerDevelopment(): boolean {
        return import.meta.env.VITE_APP_ENDPOINT_URL === "developmentServer";
    }

    /*
     * returns the api endpoint based on the environment
     */
    public static getApiEndpoint(): string {
        const endpoint = import.meta.env.VITE_APP_ENDPOINT_URL;
        console.log("endpoint: ", endpoint);
        if (endpoint === undefined) return "https://localhost:7094";
        return endpoint;
    }
}
